export default __webpack_public_path__ + "static/media/Initiate's Boots of the Effulgent Blade.cb6f5629.jpg";